// Generated by purs version 0.14.4
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Internal_Stringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign_JSON from "../Foreign.JSON/index.js";
var genericEncode = function (dictGeneric) {
    return function (dictGenericEncode) {
        return function (opts) {
            var $10 = Foreign_Generic_Class.encodeOpts(dictGenericEncode)(opts);
            var $11 = Data_Generic_Rep.from(dictGeneric);
            return function ($12) {
                return $10($11($12));
            };
        };
    };
};
var genericEncodeJSON = function (dictGeneric) {
    return function (dictGenericEncode) {
        return function (opts) {
            var $13 = genericEncode(dictGeneric)(dictGenericEncode)(opts);
            return function ($14) {
                return Foreign_Internal_Stringify.unsafeStringify($13($14));
            };
        };
    };
};
var genericDecode = function (dictGeneric) {
    return function (dictGenericDecode) {
        return function (opts) {
            var $15 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Generic_Rep.to(dictGeneric));
            var $16 = Foreign_Generic_Class.decodeOpts(dictGenericDecode)(opts);
            return function ($17) {
                return $15($16($17));
            };
        };
    };
};
var genericDecodeJSON = function (dictGeneric) {
    return function (dictGenericDecode) {
        return function (opts) {
            return Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(genericDecode(dictGeneric)(dictGenericDecode)(opts))(Foreign_JSON.parseJSON);
        };
    };
};
var encodeJSON = function (dictEncode) {
    var $18 = Foreign_Generic_Class.encode(dictEncode);
    return function ($19) {
        return Foreign_Internal_Stringify.unsafeStringify($18($19));
    };
};
var decodeJSON = function (dictDecode) {
    return Foreign_JSON.decodeJSONWith(Foreign_Generic_Class.decode(dictDecode));
};
export {
    genericDecode,
    genericEncode,
    decodeJSON,
    encodeJSON,
    genericDecodeJSON,
    genericEncodeJSON
};
export {
    ErrorAtIndex,
    ErrorAtProperty,
    ForeignError,
    TypeMismatch
} from "../Foreign/index.js";
export {
    TaggedObject,
    decode,
    defaultOptions,
    encode
} from "../Foreign.Generic.Class/index.js";
//# sourceMappingURL=index.js.map
